import supabase from '../supabase';

function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export async function uploadToB2(path, file) {
    const contentBase64 = await fileToBase64(file);
    const { data, error } = await supabase.functions.invoke('upload-to-b2', {
        body: { path, contentBase64, contentType: file.type },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data.url;
}

export async function listB2Files(prefix) {
    const { data, error } = await supabase.functions.invoke('list-b2-files', {
        body: { prefix },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data.files;
}

export async function deleteB2Files(paths) {
    const { data, error } = await supabase.functions.invoke('delete-b2-files', {
        body: { paths },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data.results;
}